module.exports = __webpack_public_path__ + "static/media/black-gold-glamour.b99e034d.jpg";